import { render, staticRenderFns } from "./TrafficLightSelector.vue?vue&type=template&id=122857f4&scoped=true&"
import script from "./TrafficLightSelector.vue?vue&type=script&lang=js&"
export * from "./TrafficLightSelector.vue?vue&type=script&lang=js&"
import style0 from "./TrafficLightSelector.vue?vue&type=style&index=0&id=122857f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122857f4",
  null
  
)

export default component.exports